export const PriorityModule = {
    namespaced: true,
    state: {
        loadPriorityData: 1,
        PriorityList: [],
        PriorityFilterList: []
    }
}